import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c65b75d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "columns is-centered" }
const _hoisted_2 = { class: "column is-full pt-6" }
const _hoisted_3 = { class: "meb-title mb-3" }
const _hoisted_4 = { class: "meb-subtitle" }
const _hoisted_5 = { class: "center-container" }
const _hoisted_6 = { class: "mt-4 es-cli-container p-1" }
const _hoisted_7 = { class: "buttons" }
const _hoisted_8 = {
  key: 0,
  class: "meb-btn-txt"
}
const _hoisted_9 = {
  key: 1,
  class: "meb-btn-txt-black"
}
const _hoisted_10 = {
  key: 0,
  class: "meb-btn-txt"
}
const _hoisted_11 = {
  key: 1,
  class: "meb-btn-txt-black"
}
const _hoisted_12 = {
  key: 0,
  class: "center-container carousel-container is-justify-content-center mt-6",
  style: {"overflow":"unset"}
}
const _hoisted_13 = {
  key: 1,
  class: "center-container carousel-container is-justify-content-center mt-6",
  style: {"overflow":"unset"}
}

import HomeSectionClienteComponent from '@/components/HomeSectionClienteComponent.vue'
import HomeSectionEsercenteComponent from '@/components/HomeSectionEsercenteComponent.vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeSection2Component',
  setup(__props) {

const buttonSel = ref (1)
function changeComp (type:number) {
  buttonSel.value = type
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('SEC_2_TITLE')), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('SEC_2_SUBTITLE')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: _normalizeClass(["button is-rounded",  1 === buttonSel.value ? 'is-primary' : 'is-white' ]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeComp(1)))
          }, [
            (1===buttonSel.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('MERCHANT_TXT')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('MERCHANT_TXT')), 1))
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass(["button is-rounded",  2 === buttonSel.value ? 'is-primary' : 'is-white' ]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeComp(2)))
          }, [
            (2===buttonSel.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('CUSTOMER_TXT')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('CUSTOMER_TXT')), 1))
          ], 2)
        ])
      ])
    ]),
    (1===buttonSel.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(HomeSectionEsercenteComponent)
        ]))
      : _createCommentVNode("", true),
    (2===buttonSel.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(HomeSectionClienteComponent)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})